export { default } from './AdminSettings';
export { default as reducer } from './AdminSettings.ducks';

import * as actions from './AdminSettings.ducks';
export { actions };
